import {useQuery} from '@tanstack/react-query'

import {QueryKeyName, getPlantQuestions} from '../../common/backend'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const usePlantQuestions = () => {
  const plantId = usePlantUpmId()

  return useQuery({
    queryKey: [QueryKeyName.GetPlantQuestions, plantId],
    queryFn: () => getPlantQuestions(plantId)
  })
}
